import { Link } from 'react-router-dom';
import { useBranding } from '../lib/branding.tsx';

export function NotFound() {
  const { branding } = useBranding();
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <div className="text-xs font-medium uppercase tracking-wide text-slate-500">404</div>
        <h1 className="mt-2 text-lg font-semibold text-slate-900">
          {branding.companyName ?? 'Compliance'}
        </h1>
        <p className="mt-2 text-sm text-slate-500">
          We couldn’t find that page.
        </p>
        <div className="mt-4 flex justify-center gap-3 text-sm">
          <Link to="/admin" className="text-blue-600 hover:underline">Admin home</Link>
          <span className="text-slate-300">·</span>
          <Link to="/c" className="text-blue-600 hover:underline">Company home</Link>
        </div>
      </div>
    </div>
  );
}
